module.exports = __webpack_public_path__ + "img/16.df81795c.png";